import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Page } from '../../../models/page.model';

@Component({
  selector: 'app-associate-page-modal',
  templateUrl: './associate-page-modal.component.html',
  styleUrl: './associate-page-modal.component.css'
})
export class AssociatePageModalComponent {
  selectedPage: string = '';
  possiblePages: Page[] = [];

  constructor(private dialogRef: MatDialogRef<AssociatePageModalComponent>, @Inject(MAT_DIALOG_DATA) public data: { sources: Page[] }) {
    this.possiblePages = data.sources;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    var page = this.possiblePages.filter(x => x.id == this.selectedPage)[0];
    this.dialogRef.close(page);
  }
}
